import { initPodsCarousels } from './carousel';
import themeEditor from './themeEditor';

const Pods = () => {
  if (document.querySelectorAll('[data-pods-carousel]').length === 0) {
    return;
  }

  initPodsCarousels();
  themeEditor();

  let previousBreakpoint = window.theme.breakpoints.current;

  window.addEventListener('breakpointChange', (e) => {
    const breakpoint = e.detail.breakpoint; // Assuming that `e.detail.breakpoint` provides the new breakpoint
    if (breakpoint !== 'mobile' && previousBreakpoint !== 'mobile') {
      return;
    }

    initPodsCarousels();
    previousBreakpoint = breakpoint;
  });
};

export { Pods };
